<template>
  <div>
    <div class="plantht">
      <div class="planttxt" style="min-height: 500px">
        <h5 class="planth5">股票池研究</h5>
        <div class="imgcontainer">
          <div
            style="padding: 17px 10px 10px 10px; margin-top: 20px"
            class="imgtop"
          >
            <TextTop></TextTop>
          </div>
          <div class="container">
            <div class="left_part">
              <ul>
                <li
                  v-for="(item, index) in leftList"
                  :key="index"
                  @click="select(item.idx)"
                  :class="selectIndex == item.idx ? 'active' : ''"
                >
                  <a>{{ item.name }}</a>
                </li>
              </ul>
            </div>
            <div class="right_part" ref="box">
              <!-- <div v-if="showlist[0]">
                <p class="title">工具一：三键下单工具</p>
                <p>
                  三键下单工具简化了交易逻辑，可一键开仓、平仓，在快进、快出的短线趋势跟踪策略中更加凸显其优势。
                </p>
                <p>
                  开仓时，点击买入、卖出按钮一键开仓；平仓时，无需关注交易方向，系统根据已有持仓自动判断平仓方向，一键平仓，高效，快捷。
                </p>
                <Imggs
                  :src="require('../../assets/img/sjxd.png')"
                  alt=""
                  @click.native="
                    showimg(require('../../assets/img/sjxd.png'))
                  "
                  width="80%"
                />
              </div> -->
              <!-- <div v-if="showlist[1]">
                <p class="title">工具二：盘口炒单工具</p>
                <p>
                  盘口炒单工具将盘口中的各档价格和挂单量直接显示在交易界面中，通过点击价格对应的买卖量，达到以指定价格发送委托的效果，省去了频繁输入价格的繁琐操作，更适合在挂单交易策略中使用。
                </p>
                <p>
                  可视化的交易界面，直接展示账户各个价位上的挂单数量、持仓情况，交易布局一目了然，有效掌控全局。
                </p>
                <Imggs
                  :src="require('../../assets/img/pkcd.jpg')"
                  alt=""
                  @click.native="
                    showimg(require('../../assets/img/pkcd.jpg'))
                  "
                  width="80%"
                />
                <p>
                  盘口炒单工具也支持网格策略，网格策略适用于震荡行情，启动后可自动循环执行高抛低吸买卖操作。
                </p>
                <p>
                  以震荡向上行情做多为例：首次开仓需手动委托（启动网格策略），开多成交后自动以成交价/委托价+M点挂出平多委托，等待高抛；高抛成交后，自动以平仓成交价/委托价-N点挂出开多委托，等待低吸；如此循环。M、N、循环次数均可设置。
                </p>
                <Imggs
                  :src="require('../../assets/img/wgcl1.png')"
                  alt=""
                  @click.native="
                    showimg(require('../../assets/img/wgcl1.png'))
                  "
                  width="80%"
                />
                <div style="text-align:center;font-size:13px;margin-top:-8px">震荡向上行情网格策略执行效果示意图</div>
              </div> -->
              <!-- <div v-if="showlist[2]" style="padding-bottom:30px">
                <p class="title">工具二：T+0持仓列表</p>

                <p>
                  T+0持仓列表将日内交易持仓从实际全部持仓中剥离出来，独立计算T+0交易持仓详情，展示了日内交易的持仓方向、开仓均价、浮动盈亏等信息，为日内平仓交易提供了分析依据。
                </p>
                <Imggs
                  :src="require('../../assets/img/cclb.jpg')"
                  alt=""
                  @click.native="
                    showimg(require('../../assets/img/cclb.jpg'))
                  "
                  width="80%"
                />

              </div> -->
              <!-- <div v-if="showlist[4]">
                <p class="title" id="id3">工具五：文件下单</p>
                <p>
                  软件扫描Excel文件里编辑好的交易指令自动下单，且支持多个文件批量扫描、控制扫描间隔，还支持自动分批下单，高效、快速、准确！
                </p>
                <Imggs
                  :src="require('../../assets/img/wjxd-1.png')"
                  alt=""
                  @click.native="
                    showimg(require('../../assets/img//wjxd-1.png'))
                  "
                  width="80%"
                />
              </div>
              <div v-if="showlist[3]">
                <p class="title" id="id3">工具四：分批下单</p>
                <p>内置多种算法，无需编写代码，填写参数即可进行分批下单。</p>
                <p>智能分批、吸筹，提高交易效率。</p>
                <p>
                  （<a href="https://www.wenhua.com.cn/popwin/5sfsm.html"
                    >点击查看算法说明</a
                  >）
                </p>
                <Imggs
                  :src="require('../../assets/img/fpxd.png')"
                  alt=""
                  @click.native="
                    showimg(require('../../assets/img/fpxd.png'))
                  "
                  width="80%"
                />
              </div>
               -->
              <div v-if="showlist[5]">
                <p class="title" id="id3">工具二：评分排名</p>
                <p>
                  筛选好企业只看技术指标是远远不够的，还要看企业的经营状况和综合竞争力。
                </p>
                <p>
                  评分排名功能从市场表现、经营能力、偿债能力等多方面，对自选股进行综合评分，通过排序的方式，筛选出自选股中竞争力强、适合长期持有的优质股票，构建投资组合。还提供了适应银行类股票的银行专项指标。 
                </p>
                <Imggs
                  :src="require('../../assets/img/wh5_p06.png')"
                  alt=""
                  @click.native="
                    showimg(require('../../assets/img/wh5_p06.png'))
                  "
                  width="80%"
                />
                <img src="../../assets/img/wh5_p07.png" alt="" />
              </div>
              <div v-if="showlist[6]">
                <p class="title" id="id3">工具一：综合k线</p>
                <p>
                  将一篮子股票、基金、债券、期货合成一个投资组合，并提供综合K线，可代替个股K线数据，实现相同逻辑的价格百分位分析，寻找最佳入场时机。还可借助盈亏分析、行业分析工具优化组合配置，构建最优投资组合。
                </p>
                <Imggs
                  :src="require('../../assets/img/wh5_p08.png')"
                  alt=""
                  @click.native="
                    showimg(require('../../assets/img/wh5_p08.png'))
                  "
                  width="80%"
                />
                <Imggs
                  :src="require('../../assets/img/wh5_p09.jpg')"
                  alt=""
                  @click.native="
                    showimg(require('../../assets/img/wh5_p09.jpg'))
                  "
                  width="80%"
                />
                <Imggs
                  :src="require('../../assets/img/wh5_p10.png')"
                  alt=""
                  @click.native="
                    showimg(require('../../assets/img/wh5_p10.png'))
                  "
                  width="80%"
                />
              </div>
              <!-- <div v-if="showlist[8]">
                <p class="title">工具九：宏观分析工具</p>
                <p>
                  判断宏观经济周期处在哪个阶段至关重要，因为你绝不会想在经济进入衰退时配置大量的股票，或是在经济复苏时持有大量现金！
                </p>
                <p>
                  wh5提供多种宏观角度的扩展分析工具，从板块分析、周期与趋势、市场相关性三个维度出发，探寻宏观经济与市场偏好的变化、市场间流动性变化和中观产业的波动关系，助力投资者发现市场风向、研判大类资产配置及市场择时、优化行业投资组合，进而提高配置效率！
                </p>
                <p>1、 板块分析</p>
                <p>
                  宏观经济环境及市场偏好的变化会导致具有不同属性的股票板块走势出现分化，因此行业板块和风格的轮动效应分析在“自上而下”的投资策略研究中举足轻重。
                </p>
                <p>
                  wh5从行业和风格维度出发，结合量化投资框架，展示了景气度、资金、动量、估值等多维数据和市场热门风格的对比，助力投资者发现市场风向、精准地把握节奏。
                </p>
                <Imggs
                  :src="require('../../assets/img/jtfx81.png')"
                  alt=""
                  @click.native="
                    showimg(require('../../assets/img/jtfx81.png'))
                  "
                  width="80%"
                />
                <p>2、周期与趋势</p>
                <p>
                  不同于传统的美林时钟等方式，wh5股票价格研究软件以实体经济和流动性的关键指标变动为核心，采取四分法对经济和金融小周期波动进行创新式划分，提供宏观指标和市场间流动性波动研判下的大类资产配置和市场择时的分析工具。
                </p>
                <Imggs
                  :src="require('../../assets/img/jtfx82.jpg')"
                  alt=""
                  @click.native="
                    showimg(require('../../assets/img/jtfx82.jpg'))
                  "
                  width="80%"
                />
                <p>3、市场相关性</p>
                <p>
                  宏观经济是各行业的组合与汇总，与行业相互联系、相互影响。行业的发展和变化也会不断反馈和改变宏观经济环境，不断优化整个经济体系。市场相关性从一系列关键指标出发，探寻了从宏观经济到中观产业的波动关系，为寻找经济传导逻辑、优化行业投资组合、提高配置效率提供辅助信息。
                </p>
                <Imggs
                  :src="require('../../assets/img/jtfx83.jpg')"
                  alt=""
                  @click.native="
                    showimg(require('../../assets/img/jtfx83.jpg'))
                  "
                  width="80%"
                />
              </div>
              <div v-if="showlist[9]">
                <p class="title">工具十：行业分析工具</p>
                <p>
                  行业分析是连接宏观经济分析和上市公司分析的桥梁，行业所处生命周期的位置，制约和决定着企业的生存和发展空间。
                </p>
                <p>
                  wh5行业中心将个股的信息整合至行业维度进行展示，是行业分析的基础。从行业市场表现、行业估值、财务数据、行业内上市公司以及行业研究热度等多个角度，全面深入解析行业之间及行业内部的情况，判定行业生命周期，挖掘最具投资潜力的行业，为下一步的投资决策提供参考。
                </p>
                <p>
                  （1）行业市场表现可横向对比行业间的量价指标（N日涨幅、N年价格分位点、平均成交额、换手率等）、相关系数、资金流向（北向净额、融资净买入和融券卖出量等）等数据，为构建行业组合提供参考。
                </p>
                <Imggs
                  :src="require('../../assets/img/wh5_p01.png')"
                  alt=""
                  @click.native="
                    showimg(require('../../assets/img/wh5_p01.png'))
                  "
                  width="80%"
                />
                <p>
                  （2）行业也可以进行估值分析，行业估值通过算法对行业涨跌中“估值驱动”和“盈利驱动”因素进行解构，以分析引起涨跌的主要驱动因素，并结合行业估值分析、业绩增速等数据进行行业涨跌判断。
                </p>
                <Imggs
                  :src="require('../../assets/img/wh5_p02.jpg')"
                  alt=""
                  @click.native="
                    showimg(require('../../assets/img/wh5_p02.jpg'))
                  "
                  width="80%"
                />
                <p>
                  （3）行业财务数据是行业基本面研究的基础。有别于同类软件粗暴地使用最新行业成分股倒推历史数据，wh5的行业表现根据所在报告期的行业实际成分股数量进行整合，更加贴合历史真实的行业发展和变化情况。
                </p>
                <Imggs
                  :src="require('../../assets/img/wh5_p03.png')"
                  alt=""
                  @click.native="
                    showimg(require('../../assets/img/wh5_p03.png'))
                  "
                  width="80%"
                />
                <p>
                  （4）行业上市公司统计从公司地域分布、公司上市板块分布、上市公司历史趋势、现金分红以及集中度等多方面展现行业内上市公司的分布情况，对比行业成分股的表现，研判行业竞争结构和垄断程度，辨别行业生命周期。
                </p>
                <Imggs
                  :src="require('../../assets/img/wh5_p04.png')"
                  alt=""
                  @click.native="
                    showimg(require('../../assets/img/wh5_p04.png'))
                  "
                  width="80%"
                />
                <p>
                  （5）行业研究热度展现了近30天的研报以及投资者调研活动的行业统计情况，辅助投资者分析市场关注热度。
                </p>
                <Imggs
                  :src="require('../../assets/img/wh5_p05.png')"
                  alt=""
                  @click.native="
                    showimg(require('../../assets/img/wh5_p05.png'))
                  "
                  width="80%"
                />
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <Baseimg :src="src" :show="ifimg" @change="ifimg = false" />
  </div>
</template>

<script>
import Baseimg from "./frame/Baseimg.vue";
import Imggs from "./frame/Imggs.vue";
export default {
  components: { Baseimg, Imggs },
  data() {
    return {
      leftList: [
        // { name: "三键下单工具",idx:0 },
        // // { name: "盘口炒单工具" },
        // // { name: "网格策略工具" },
        // { name: "T+0持仓列表",idx:2  },
        // { name: "分批下单" },
        // { name: "文件下单" },
        { name: "综合k线",idx:6  },
        { name: "评分排名",idx:5  },
        // { name: "宏观分析工具" },
        // { name: "行业分析工具" },
      ],
      showlist: [true, false, false, false, false, false, false, false,],
      selectIndex: 0,
      src: "",
      ifimg: false,
    };
  },
  methods: {
    select(index) {
      this.showlist.forEach((el, idx) => {
        this.showlist[idx] = false;
      });
      this.showlist[index] = true;
      this.selectIndex = index;
      // this.custormAnchor(`id${index + 1}`);
    },
    showimg(e) {
      console.log(e);
      this.src = e;
      this.ifimg = true;
    },
    // custormAnchor(anchorName) {
    //   var target = document.getElementById(anchorName);
    //   if (target !== null) {
    //     this.$refs.box.scrollTop = target.offsetTop;
    //   }
    // },
  },
  mounted() {
    this.select(this.$route.params.id);
  },
};
</script>

<style scoped>
.packkua {
  width: 900px;
  margin: 0 auto;
  min-height: 0px;
  margin-top: 50px;
}
.packh4 {
  background: #f5e5e5;
  height: 25px;
}
.h4img {
  float: left;
  margin-top: -12px;
}
.imgcontainer {
  padding: 0 10px;
  background: #f5f5f5;
}
.h4ti {
  width: 95px;
  border-radius: 0 0 30px 0;
  background: #e04a49;
  float: left;
  height: 25px;
  color: white;
  line-height: 24px;
  font-size: 16px;
  padding-left: 7px;
}
.kuatxt {
  padding: 20px 0 40px 0;
  width: 100%;
}
.kuatxt p {
  line-height: 25px;
  padding: 10px 0;
  font-size: 14px;
  text-indent: 2em;
  color: #6f6f6f;
  text-align: justify;
}
.plantht {
  min-height: 600px;
  background: url(https://wh-api.wenhua.com.cn/api/WhBanner/GetWhBannerUrl?id=11) no-repeat top;
  overflow: hidden;
}
.planttxt {
  width: 990px;
  border-radius: 5px;
  margin: 0 auto;
  margin-top: 236px;
  padding: 30px 30px 0 30px;
  background: white;

  box-shadow: 0 0 20px -5px #ccc;
}
.planth5 {
  font-size: 22px;
  color: #5f5f5f;
  border-bottom: 1px dashed #7f7f7f;

  line-height: 40px;
}
.planth4 {
  background: #ffe9dc;
  height: 25px;
  width: 920px;
}
.h4ti1 {
  width: 111px;
  border-radius: 0 0 30px 0;
  background: #e0a180;
  float: left;
  height: 25px;
  color: white;
  line-height: 24px;
  font-size: 16px;
  padding-left: 7px;
}
.kuatxt p {
  width: 600px;
  line-height: 25px;
  text-align: justify;
}
.kuatxt {
  width: 600px;
  display: inline-block;
}
.imgs {
  display: inline-block;
  margin-left: 30px;
}
.imgtop div {
  color: #292929;
  text-indent: 2em;
  font-size: 15px;
  padding: 5px 0;
}
.container {
  width: 100%;
  position: relative;
  background: white;
  margin-top: 20px;
}
.right_part::-webkit-scrollbar {
  width: 0;
}
.left_part {
  display: inline-block;
  width: 195px;
  height: 100%;
}
.left_part .title {
  width: calc(100% - 20px);
  height: 45px;
  line-height: 45px;
  font-size: 16px;
  /* font-weight: bold; */
  background: url(../../assets/img/ts2.jpg) no-repeat center;
  background-size: 100% 100%;
  vertical-align: top;
  color: #fff;
  padding-left: 20px;
}
.left_part ul li {
  height: 50px;
  line-height: 50px;
  cursor: pointer;
  font-size: 15px;
  color: #827373;
  border-bottom: 1px solid #ececec;
}
.left_part ul li:hover {
  color: #b56f6f;
}
.left_part ul li.active {
  background: #e57373;
  /* box-shadow: 2px 4px 4px #bebcbc inset; */
  color: white;
}
.left_part ul li a {
  width: 85%;
  margin: 0 auto;
  display: block;
  text-indent: 1em;
  position: relative;
  top: -1px;
}
.left_part ul li.active  a{
  border-bottom: none;
}
.right_part {
  display: inline-block;
  width: 695px;
  height: 100%;
  vertical-align: top;
  background: #f5f5f5;
  padding: 20px 40px;
  color: #8a8a8a;
  /* box-shadow: -4px 4px 4px #bebcbc inset; */
  background: #efefef;
}
.right_part p {
  text-indent: 2em;
  padding: 5px 0;
  font-size: 14px;
  text-align: justify;
  line-height: 24px;
}
.right_part img {
  margin: 20px auto;
  display: block;
}
.right_part .title {
  font-size: 16px;
  font-weight: bold;
  text-indent: 0;
  color: #7e4040;
}
p a {
  color: rgb(43, 100, 179);
}
</style>